import LineUserList from './LineUserList';

export default {
  list: LineUserList,
};
